import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { MetricsPage } from "./-metrics/metrics.page";

export const Route = createFileRoute("/warehouse/metrics/")({
  validateSearch: validateGridSearch,
  component: MetricsPage,
});
